// Where an InfoButton's note goes: under its (i), as wide as the screen allows
// up to NOTE_MAX, never closer than NOTE_MARGIN to either edge, with the
// pointer aimed at the button's middle (kept off the rounded corners).

export const NOTE_MARGIN = 16
export const NOTE_MAX = 360
const GAP = 10
const CORNER = 20

export interface NotePlacement { left: number; width: number; top: number; arrow: number }

export function placeNote(
  anchor: { left: number; width: number; bottom: number },
  viewport: number,
): NotePlacement {
  const width = Math.min(NOTE_MAX, viewport - 2 * NOTE_MARGIN)
  const centre = anchor.left + anchor.width / 2
  const left = Math.min(Math.max(centre - width / 2, NOTE_MARGIN), viewport - NOTE_MARGIN - width)
  const arrow = Math.min(Math.max(centre - left, CORNER), width - CORNER)
  return { left, width, top: anchor.bottom + GAP, arrow }
}

/** Height a tour card needs to sit beside what it points at without crowding it. */
const CARD_ROOM = 220

export type CoachmarkPlacement =
  | { side: 'below'; left: number; width: number; top: number; arrow: number }
  | { side: 'above'; left: number; width: number; bottom: number; arrow: number }

/**
 * Where the tour's card goes (components/ui/Coachmark): like a note, but above
 * its target when that is docked low on the screen (quick add, Start shopping),
 * else below; with no room either side, wherever there is more.
 */
export function placeCoachmark(
  target: { top: number; bottom: number; left: number; width: number },
  viewport: { width: number; height: number },
): CoachmarkPlacement {
  const { left, width, arrow } = placeNote(target, viewport.width)
  const below = viewport.height - target.bottom
  const above = target.top
  const goBelow = below >= CARD_ROOM || (above < CARD_ROOM && below >= above)
  return goBelow
    ? { side: 'below', left, width, top: target.bottom + GAP, arrow }
    : { side: 'above', left, width, bottom: viewport.height - target.top + GAP, arrow }
}
